import Vue from 'vue'
import Vuex from 'vuex'
import menus from './menus'
import globalTips from './global_tips'
import profile from './profile'

Vue.use(Vuex)

export default new Vuex.Store({
  state: Object.assign({
    routeKey: 1,
    uploadData: null,
    menus,
    globalTips,
    tpmsfieldmap: require('../store/tpmsfieldmap').default
  }, profile),
  getters: {
    menus(state) {
      return state.menus
    }
  },
  mutations: {
    routeReload(state) {
      state.routeKey++;
    },
    setUploadData(state, payload) {
      state.uploadData = payload;
    },
    setRes(state, payload) {
      state.res = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
